export default "__VITE_ASSET__B8S$0InW__"